import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#EB6305',
  secondary: '#2B4F75',
  accent: '#F20520',
  info: '#192E40',
}

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg' || 'faSvg',
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  defaults: {
    VSheet: {
      elevation: 0,
    },
  },
})
